import { useEffect, useState } from 'react';
import config from '../config';
import { sentry } from '../lib/sentry';
const getUserGroupSettings = async _ref => {
  let {
    environment,
    userId
  } = _ref;
  const groupsGraphUrl = config(environment).urls.GROUP_HUB_API;
  const response = await fetch(groupsGraphUrl, {
    body: JSON.stringify({
      query: "\n          query($user_id: Int!) {\n            groupsByUser(userId: $user_id) {\n              edges {\n                node {\n                  id\n                  status\n                  name\n                  groupType\n                }\n              }\n            }\n          }",
      variables: {
        user_id: userId
      }
    }),
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'POST'
  });
  const responseBody = await response.json();
  const groups = responseBody.data.groupsByUser.edges;
  const validGroups = groups.filter(_ref2 => {
    let {
      node
    } = _ref2;
    return node.status !== 'cancelled';
  });
  return {
    isUserB2B: validGroups.some(_ref3 => {
      let {
        node
      } = _ref3;
      return node.groupType === 'enterprise';
    }),
    isUserFromDatacamp: validGroups.some(_ref4 => {
      let {
        node
      } = _ref4;
      return node.name.includes('DataCamp');
    })
  };
};
export const useUserGroupSettings = _ref5 => {
  let {
    environment,
    userId
  } = _ref5;
  const [state, setState] = useState({
    type: 'loading'
  });
  useEffect(() => {
    const fetchUserGroupSettings = async () => {
      try {
        if (userId == null) {
          setState({
            type: 'success',
            userGroupSettings: {
              isUserB2B: false,
              isUserFromDatacamp: false
            }
          });
          return;
        }
        setState({
          type: 'loading'
        });
        const userGroupSettings = await getUserGroupSettings({
          environment,
          userId
        });
        setState({
          type: 'success',
          userGroupSettings
        });
      } catch (error) {
        sentry.captureError(error, {
          exerciseType: 'VideoExercise',
          message: 'Error while fetching user groups'
        });
        setState({
          type: 'error'
        });
      }
    };
    fetchUserGroupSettings();
  }, [environment, userId]);
  return state;
};